import React, { useContext, useEffect, useState } from 'react'
import css from "../style.module.css"
import AdminTable from './AdminTable'
import { AdminPanelContext } from '../../../Context/AdminPanelContext'
import BackSection from '../../Services/BackSection';

export default function AdminPanel() {
    const { adminPanelData } = useContext(AdminPanelContext);

    const [usersData, setUsersData] = useState([]);

    const usersList = Array.isArray(usersData.usersList) ? usersData.usersList : [];
    const stats = usersList.reduce((acc, user) => {
        acc.allUsers += 1;
        if (user.role === "admin") acc.adminUsers += 1;
        if (user.role === "marketing") acc.marketingTeam += 1;
        if (user.role === "compliance") acc.complianceTeam += 1;
        if (user.role === "baseUser") acc.baseUsers += 1;
        return acc;
    }, {
        allUsers: 0,
        adminUsers: 0,
        marketingTeam: 0,
        complianceTeam: 0,
        baseUsers: 0,
    });

    useEffect(() => {
        if (adminPanelData) {
            setUsersData(adminPanelData);
        }
    }, [adminPanelData]);

    return (
        <section>
            <BackSection pageName="Internal Users" to={"/setup"} />
            <div className="row mb-5">
                <div className="my-4 d-flex align-items-center gap-3">
                    <div className={css.adminPanelBox}>
                        <div className={css.adminPanelBox__count}>{stats.allUsers}</div>
                        <div className={css.adminPanelBox__label}>All Users</div>
                    </div>
                    <div className={css.adminPanelBox}>
                        <div className={css.adminPanelBox__count}>{stats.adminUsers}</div>
                        <div className={css.adminPanelBox__label}>Admins</div>
                    </div>
                    <div className={css.adminPanelBox}>
                        <div className={css.adminPanelBox__count}>{stats.marketingTeam}</div>
                        <div className={css.adminPanelBox__label}>Marketing Team</div>
                    </div>

                    <div className={css.adminPanelBox}>
                        <div className={css.adminPanelBox__count}>{stats.complianceTeam}</div>
                        <div className={css.adminPanelBox__label}>Compliance Team</div>
                    </div>

                    <div className={css.adminPanelBox}>
                        <div className={css.adminPanelBox__count}>{stats.baseUsers}</div>
                        <div className={css.adminPanelBox__label}>Base Users</div>
                    </div>
                </div>
                <AdminTable usersList={usersList} />
            </div>
        </section>
    )
}
